export const PARTIALLY_SHIPPED_THE_TRANSFER_REQUEST =
  'Partially Shipped the Transfer Request';
export const FULLY_SHIPPED_THE_TRANSFER_REQUEST =
  'Fully Shipped The Transfer Request';
export const ERROR_MESSAGE_ITEMS_OR_INGREDIENTS_MORE_THAN_50 =
  'Max 50 items/ingredients';
